















































































































































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import BaseSuketCard from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketCard.vue";
import StoreSuketLayakVaksin from "@/store/modules/SuketLayakVaksin";
import CommonSuket, { EnSuketCategory } from "@/services/CommonSuket";
import BaseSuketTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketTabPage";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { storeDokter } from "@/store/modules/dokter";
import { SuketBaseWithRelationship } from "@/types/suket_layak_vaksin";

import pdf from "vue-pdf";

@Component({
  components: {
    CardModalTtd,
    BaseSuketCard,
    pdf
  }
})
export default class SuketLayakVaksinTabPage extends BaseSuketTabPage {
  @Prop() declare readonly register: string | number;

  allowedUnit = ["2P", "06", "2A"];
  suketSvc = new CommonSuket(EnSuketCategory.LayakVaksin);
  suketStore = StoreSuketLayakVaksin;

  get pdfUrl() {
    return this.dataSuket
      ? this.getSuketPdfUrl(EnSuketCategory.LayakVaksin, this.dataSuket.id)
      : null;
  }

  register_id = this.register;
  pasien_rm = this.pasien.rm;
  unit_id = this.user.unit_id;
  nama = this.pasien.nama;
  rm = this.pasien.rm;
  tgl_lahir = this.pasien.tgl_lahir;
  nik = this.pasien.nik;
  paspor = this.getPaspor();
  sex = this.pasien.jk;
  keadaan = null;
  vaksin = null;
  surat_date = new Date();
  signee_user_id = this.user.id;
  creator_user_id = this.user.id;
  alasan = null;
  number = null;
  satuan = null;
  catatan = null;
  validasi = [v => !!v || "*Kolom ini harus diisi"];
  msg = "";
  validasiNumber = [v => this.cek(v) || this.message()];
  saving = false;
  showInputTujuan = true;
  loadedRatio = 0;
  keadaanOptions = [
    {
      id: 1,
      name: "TIDAK LAYAK",
      name_en: "CAN NOT"
    },
    {
      id: 2,
      name: "LAYAK",
      name_en: "CAN"
    }
  ];
  satuanOptions = [
    {
      id: 1,
      name: "Hari",
      name_en: "Day"
    },
    {
      id: 2,
      name: "Bulan",
      name_en: "Month"
    },
    {
      id: 3,
      name: "Tahun",
      name_en: "Year"
    }
  ];

  getPaspor() {
    if (this.pasien && this.pasien.idcard && this.pasien.idcard.length > 0) {
      const pp = this.pasien.idcard.filter(val => val.type == "passport");
      if (pp.length > 0) return pp[0].nomor;
    } else {
      return null;
    }
  }

  @Watch("loadedRatio")
  changeLoadedRatio(val) {
    console.log("change loaded ratio", val);
  }

  mounted() {
    this.register_id = this.dataSuket?.register_id || this.register;
    this.pasien_rm = this.dataSuket?.pasien_rm || this.pasien.rm;
    this.unit_id = this.dataSuket?.unit_id || this.user.unit_id;
    this.nama = this.pasien.nama;
    this.rm = this.pasien.rm;
    this.tgl_lahir = this.pasien.tgl_lahir;
    this.nik = this.pasien.nik;
    this.sex = this.pasien.jk;
    this.keadaan = this.dataSuket?.content.keadaan || null;
    this.vaksin = this.dataSuket?.content.vaksin || null;
    this.alasan = this.dataSuket?.content.alasan || null;
    this.number = this.dataSuket?.content.number || null;
    this.satuan = this.dataSuket?.content.satuan || null;
    this.paspor = this.dataSuket?.content.paspor || this.getPaspor();
    this.catatan = this.dataSuket?.content.hasil.catatan;
    this.surat_date = this.dataSuket?.surat_date || new Date();
    this.signee_user_id = this.dataSuket?.signee_user_id || this.user.id;
    this.creator_user_id = this.dataSuket?.creator_user_id || this.user.id;
  }

  get pasien() {
    return storePasien.identitasPasien;
  }

  get user() {
    return userModule.user;
  }

  get input() {
    return {
      register_id: this.register_id,
      pasien_rm: this.pasien_rm,
      unit_id: this.unit_id,
      content: {
        keadaan: this.keadaan,
        vaksin: this.vaksin,
        alasan: this.alasan,
        number: this.number,
        satuan: this.satuan,
        paspor: this.paspor,
        catatan: this.catatan
      },
      surat_date: this.surat_date,
      signee_user_id: this.signee_user_id,
      creator_user_id: this.creator_user_id
    };
  }

  get listDokter() {
    return storeDokter.list;
  }

  get canSign() {
    return this.user.id == this.signee_user_id;
  }

  save() {
    if (!this.saving) {
      this.saving = true;

      const action = this.dataSuket
        ? this.suketSvc.update(this.dataSuket.id, this.input)
        : this.suketSvc.create(this.input);

      action
        .then(() => {
          if (this.canSign) {
            this.showSignatureModal();
          }

          appModule.NoticeDelay("Berhasil Simpan");

          this.close();
          StoreSuketLayakVaksin.getSuketByRegister(this.register);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  close() {
    this.expandInput = false;
  }

  @Watch("dataSuket")
  changeDataSuket(val: SuketBaseWithRelationship) {
    if (val) {
      this.register_id = val.register_id;
      this.pasien_rm = val.pasien_rm.toString();
      this.unit_id = val.unit_id;
      this.nama = this.pasien.nama;
      this.rm = this.pasien.rm;
      this.tgl_lahir = this.pasien.tgl_lahir;
      this.nik = this.pasien.nik;
      this.paspor = this.getPaspor();
      this.sex = this.pasien.jk;
      this.keadaan = val.content.keadaan;
      this.vaksin = val.content.vaksin;
      this.alasan = val.content.alasan;
      this.number = val.content.number;
      this.satuan = val.content.satuan;
      this.paspor = val.content.paspor;
      this.catatan = val.content.catatan;
      this.surat_date = val.surat_date;
      this.signee_user_id = val.signee_user_id;
      this.creator_user_id = val.creator_user_id;
    } else {
      this.register_id = this.register;
      this.pasien_rm = this.pasien.rm;
      this.unit_id = this.user.unit_id;
      this.nama = this.pasien.nama;
      this.rm = this.pasien.rm;
      this.tgl_lahir = this.pasien.tgl_lahir;
      this.nik = this.pasien.nik;
      this.paspor = this.getPaspor();
      this.sex = this.pasien.jk;
      this.keadaan = null;
      this.vaksin = null;
      this.alasan = null;
      this.number = null;
      this.satuan = null;
      this.catatan = null;
      this.surat_date = new Date();
      this.signee_user_id = this.user.id;
      this.creator_user_id = this.user.id;
    }
  }

  @Watch("pasien")
  changeDataPaspor(val) {
    this.paspor = this.getPaspor();
  }

  refresh() {
    storePasien.act_pasien_last_reg(this.rm);
  }

  cek(v) {
    if (isNaN(Number(this.number)))
      this.number = this.number.substring(0, this.number.length - 1);
    if (v == "" || v == null) {
      this.msg = "*Kolom Angka harus diisi";
      return false;
    } else if (Number(v) > 999) {
      this.msg = "*Anda yakin angka diisi " + v + "?";
      return false;
    } else return true;
  }
  message() {
    return this.msg;
  }
}
